import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-293c2f85"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-2xl mb-4" }, "Receive NFTs", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-light text-gray-info text-sm mb-4" }, " Enter your email to see your previous donations. ", -1))
const _hoisted_3 = { class: "flex items-end" }
const _hoisted_4 = { class: "w-full mr-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Email", -1))
const _hoisted_6 = { style: {"width":"132px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Search", -1))

import { onMounted, ref } from 'vue';
import Moralis from 'moralis';
import { MoralisKey } from '@/symbols/moralis';
import { inject } from 'vue';


export default /*#__PURE__*/_defineComponent({
  emits: ['update'],
  setup(__props, { emit: emits }) {

const moralis = inject(MoralisKey, Moralis);
const email = ref('');



const toggleSeaarch = async () => {
  localStorage.setItem('donate_email', email.value);

  const data = await moralis.Cloud.run('getPaymentTransactionsByEmail', {
    size: 20,
    page: 1,
    email: email.value,
  });
  emits('update', data);
};

onMounted(() => {
  email.value = localStorage.getItem('donate_email') || '';
  toggleSeaarch();
});

return (_ctx: any,_cache: any) => {
  const _component_BaseInputText = _resolveComponent("BaseInputText")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseBox = _resolveComponent("BaseBox")!

  return (_openBlock(), _createBlock(_component_BaseBox, { class: "search-email card" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_BaseInputText, {
            style: {"height":"44px"},
            modelValue: email.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            type: "email",
            "data-testid": "receive-serch-email"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_BaseButton, {
            full: "",
            style: {"height":"44px"},
            "color-scheme": "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSeaarch())),
            "data-testid": "receive-search-btn"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})